import React from 'react';
import './WhyBookSection.css';

function WhyBookSection() {
  const benefits = [
    {
      title: 'Custom Made Safaris',
      description: 'We offer pre planned or custom made itineraries to fit exactly to your budget, we take care of everything for your Tanzania and Zanzibar beach holiday.'
    },
    {
      title: 'Best Prices Guaranteed',
      description: 'With Local Experience, We give best suggestions that will fit your Time schedule, Type of safari and Accommodations that are quality and fits your budget.'
    },
    {
      title: '24/7 Quick Response',
      description: 'Our team is committed to answering all your questions promptly and professionally—always expect nothing less than the best.'
    }
  ];

  return (
    <section className="why-book-section">
      <div className="why-book-container">
        <h2 className="why-book-title">
          Why Book with <span className="company-name">Digital Dream Safaris</span>
        </h2>
        
        <div className="why-book-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="why-book-card">
              <h3 className="why-book-card-title">{benefit.title}</h3>
              <p className="why-book-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyBookSection;

